import { DropdownMenuCheckboxItem } from '@/components/shadcn/dropdown-menu';
import React from 'react';

const UserSettingsDropdownCheckboxItem = React.forwardRef<
  React.ElementRef<typeof DropdownMenuCheckboxItem>,
  React.ComponentPropsWithoutRef<typeof DropdownMenuCheckboxItem>
>(({ children, checked, onCheckedChange, ...props }, ref) => {
  return (
    <DropdownMenuCheckboxItem
      ref={ref}
      className='text-base'
      checked={checked}
      onCheckedChange={onCheckedChange}
      onSelect={async (e) => {
        e.preventDefault();
      }}
      {...props}
    >
      {children}
    </DropdownMenuCheckboxItem>
  );
});
UserSettingsDropdownCheckboxItem.displayName =
  DropdownMenuCheckboxItem.displayName;
export { UserSettingsDropdownCheckboxItem };
